import React, { useState, useReducer, useEffect } from "react"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  LinearProgress,
  CircularProgress,
  MenuItem,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Alert,
  Autocomplete,
} from "@mui/material"
import { Link } from "react-router-dom"

import { getCurrentUser, enumToArray } from "helpers/service_helper"
import { FileGasProjectType } from "models/types/file-gas-project-type"
import { PackageCompanyType } from "models/types/package-company-type"
const ProjectPackage = ({ rowData, mainProps, setErrorMessage }) => {
  const { lstPackageInstaller, t } = mainProps

  const style = {
    // border: "2px solid #000",
    p: 2,
  }

  const [packageCompanyType, setPackageCompanyType] = useState([])
  const [selectPackageCompany, setSelectPackageCompany] = useState(0)
  useEffect(() => {
    setPackageCompanyType(enumToArray(PackageCompanyType))
  }, [])

  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      gasProjectId: rowData.id,
      packageInstallerId: rowData.packageInstaller?.id,
    }
  )
  const [open, setOpen] = useState(false)
  const [inputValue, setInputValue] = useState("")
  const [valueInstaller, setValueInstaller] = useState(
    rowData.packageInstaller?.fullName
  )
  useEffect(() => {}, [])

  const handleInput = evt => {
    const name = evt.target.name
    const newValue = evt.target.value
    setFormInput({ [name]: newValue })
  }
  const saveToDatabase = async values => {
    const { onAddPackageInstaller } = mainProps
    await onAddPackageInstaller(values)
  }
  const handleSubmitForm = async (event, values) => {
    event.preventDefault()
    if (
      window.confirm(
        "بعد از تایید یک پیام برای نصاب ارسال میگردد که باید آنرا تایید کند"
      )
    ) {
      if (
        formInput.gasProjectId.length !== 0 &&
        formInput.packageInstallerId.length !== 0
      ) {
        await saveToDatabase(formInput)
      }

      // await onGetProjectFiles(formInput.idGasProject)
    }
  }
  return (
    <div>
      {rowData.packageNeed ? (
        <div>
          <Button
            variant="outlined"
            size="small"
            disabled={rowData.packageInstallerSubmit}
            onClick={async () => {
              const { onGetPackageInstaller } = mainProps
              await onGetPackageInstaller("ایران رادیاتور")
              setOpen(prev => !prev)
            }}
          >
            {rowData.packageInstallerSubmit ? (
              "نصاب تایید شده"
            ) : rowData.countOfProjectPackages > 1 || rowData.packageCount > 1 ? (
              <Link
                to={`/projects/GasProjectExecutor/${rowData?.id}`}
                style={{ textDecoration: "none" }}
              >
                پکیج هاو نصاب
              </Link>
            ) : (
              "نصاب"
            )}
          </Button>

          <Dialog
            open={open}
            onClose={() => {
              setOpen(false)
            }}
          >
            <form onSubmit={handleSubmitForm}>
              <DialogTitle>مدیریت نصاب: {rowData.fileNumber}</DialogTitle>
              <DialogContent>
                <DialogContentText>تایید نصاب</DialogContentText>
                <Grid item xs={12}>
                  {mainProps.gasProjectError ? (
                    <Alert severity="error">{mainProps.gasProjectError}</Alert>
                  ) : null}
                  {mainProps.gasProjectSuccess ? (
                    <Alert severity="success">
                      {mainProps.gasProjectSuccess}
                    </Alert>
                  ) : null}
                </Grid>
                <Box sx={{ ...style }}>
                  <Grid container spacing={2}>
                    <Grid item xs={9}>
                      <FormControl size="small" fullWidth>
                        <InputLabel id="select-label-PackageCompany">
                          شرکت
                        </InputLabel>
                        <Select
                          labelId="select-label-PackageCompany"
                          name="PackageCompany"
                          value={selectPackageCompany}
                          label="شرکت"
                          onChange={async e => {
                            setSelectPackageCompany(e.target.value)
                            console.log("e.target.value", e.target.value)
                            setValueInstaller(null)
                            const { onGetPackageInstaller } = mainProps
                            const selectCompany = t(
                              "enums." + packageCompanyType[e.target.value].name
                            )
                            await onGetPackageInstaller(selectCompany)
                          }}
                        >
                          {packageCompanyType &&
                            packageCompanyType.map(row => {
                              return (
                                <MenuItem key={row.id} value={row.id}>
                                  {t("enums." + row.name)}
                                </MenuItem>
                              )
                            })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        value={valueInstaller}
                        onChange={(e, value) => {
                          if (value.id) {
                            const iValue = {
                              target: {
                                name: "packageInstallerId",
                                value: value.id,
                              },
                            }
                            handleInput(iValue)
                            setValueInstaller(value)
                          }
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                          setInputValue(newInputValue)
                        }}
                        id="packageInstallerId"
                        options={lstPackageInstaller.map(option => ({
                          id: option.id,
                          label:
                            option.fullName +
                            "/" +
                            option.mobileNumber +
                            "/" +
                            option.companyName,
                        }))}
                        sx={{ width: 380 }}
                        renderInput={params => (
                          <TextField {...params} label="انتخاب نصاب" required />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </DialogContent>

              <DialogActions>
                <Box sx={{ ...style }}>
                  {mainProps.loading ? (
                    <CircularProgress disableShrink />
                  ) : (
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Button variant="contained" type="submit">
                          ذخیره و ارسال
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </Box>
              </DialogActions>
            </form>
          </Dialog>
        </div>
      ) : (
        "پکیج ندارد"
      )}
    </div>
  )
}

ProjectPackage.propTypes = {}

export default ProjectPackage
